module.exports = __webpack_public_path__ + "img/19_87_957_ELCA_VW_LandingPage_Image3.2103bf7c.jpg";